// src/services/takeoutService.js
// 外帶訂單 — Admin API 客戶端（Plan 106）
// 對應後端 /api/takeout/*（JWT）。一律 return res.data（gotcha #9）。
import apiService from './apiService';

const { apiRequest } = apiService;

// GET /api/takeout/orders?date=&status= → { success, date, orders:[…], counts:{…} }
const getOrders = async ({ date, status } = {}) => {
  const qs = new URLSearchParams();
  if (date) qs.set('date', date);
  if (status) qs.set('status', status);
  const res = await apiRequest('get', `takeout/orders${qs.toString() ? `?${qs}` : ''}`);
  return res.data;
};

// PATCH /api/takeout/orders/:id/status  body: { status } → { success, order }
const updateStatus = async (id, status) => {
  const res = await apiRequest('patch', `takeout/orders/${encodeURIComponent(id)}/status`, { status });
  return res.data;
};

const takeoutService = { getOrders, updateStatus };
export default takeoutService;
